import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { listProjects } from '../registry';
import { ProjectCard } from './ProjectCard';

// Portfolio showcase grid for the home page.
// Prefer featured projects; if fewer than `limit` are flagged, fill from the
// rest (newest first) so the home grid never looks thin.
export function FeaturedWork({ limit = 9 }: { limit?: number }) {
  const { t } = useTranslation('common');
  const all = listProjects();
  const featured = all.filter((p) => p.featured);
  const rest = all.filter((p) => !p.featured);
  const projects = (featured.length >= limit ? featured : [...featured, ...rest]).slice(0, limit);

  return (
    <section className="py-24 sm:py-32 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-cyan/5 to-transparent pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 glass rounded-full mb-4">
              <span className="w-2 h-2 bg-neon-green rounded-full animate-pulse" />
              <span className="text-sm font-medium text-neon-green">{t('portfolioIndex.badge')}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-text-primary font-heading">{t('portfolioIndex.sectionTitle')}</h2>
            <p className="mt-2 text-text-secondary max-w-2xl">{t('portfolioIndex.sectionSubtitle')}</p>
          </div>
          <Link
            to="/portfolio"
            className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-xl glass-card text-text-secondary hover:text-neon-cyan hover:border-neon-cyan/30 border border-white/5 transition-all duration-300 whitespace-nowrap focus-ring"
          >
            {t('portfolioIndex.viewAll')}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p) => (
            <ProjectCard key={p.slug} project={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
